import React, { useState, useEffect } from 'react'
import PopUp from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { AddAdminMasterPincodeData, updateAdminMasterPincodeData } from '../../AdminActionCreator.component'

const EMPTY_FORM = {
    pincode: '',
    nearbyArea: '',
    hqPincode: '',
    spokeLocation: '',
    hub: '',
    state: '',
    distanceFromSpoke: '',
    isActive: true
}

export default function AddEditPincode({ editData, handleSavebtn }) {
    const isEdit = editData && Object.keys(editData).length > 0
    const pageTitle = isEdit ? 'Edit Pincode' : 'Add Pincode'

    const [loader, setLoader] = useState(false)
    const [popupState, setPopupState] = useState(false)
    const [popupStatus, setPopupStatus] = useState('')
    const [data, setData] = useState(EMPTY_FORM)

    useEffect(() => {
        if (isEdit) {
            setData({
                pincode: editData.pincode || '',
                nearbyArea: editData.nearbyArea || '',
                hqPincode: editData.hqPincode || '',
                spokeLocation: editData.spokeLocation || '',
                hub: editData.hub || '',
                state: editData.state || '',
                distanceFromSpoke: editData.distanceFromSpoke != null ? editData.distanceFromSpoke : '',
                isActive: editData.isActive !== undefined ? editData.isActive : true
            })
        }
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target
        setData(prev => ({ ...prev, [name]: value }))
    }

    const handleToggle = () => {
        setData(prev => ({ ...prev, isActive: !prev.isActive }))
    }

    const removePopup = () => {
        setTimeout(() => {
            setPopupState(false)
            setPopupStatus('')
        }, 3000)
    }

    const closePopup = () => setPopupState(false)

    const handleSave = (type) => {
        if (type === 'back') {
            handleSavebtn()
            return
        }

        if (!String(data.pincode).trim()) {
            setPopupState(true)
            setPopupStatus('Pincode is required!')
            removePopup()
            return
        }

        // Build payload matching API shape
        const payload = {
            pincode: data.pincode,
            nearbyArea: data.nearbyArea,
            hqPincode: data.hqPincode,
            spokeLocation: data.spokeLocation,
            hub: data.hub,
            state: data.state,
            distanceFromSpoke: data.distanceFromSpoke !== '' ? parseFloat(data.distanceFromSpoke) : null,
            isActive: data.isActive
        }

        setLoader(true)

        if (type === 'save') {
            AddAdminMasterPincodeData(payload, callback => {
                setLoader(false)
                const isSuccess = callback && (
                    callback.id ||
                    callback.message === 'success' ||
                    callback.status === 'success' ||
                    callback === 'success'
                )
                if (isSuccess) {
                    setPopupState(true)
                    setPopupStatus('Pincode added successfully!')
                    setTimeout(() => handleSavebtn(), 2000)
                } else {
                    setPopupState(true)
                    setPopupStatus(callback?.message || 'Something went wrong, please try again!')
                    removePopup()
                }
            })
        } else if (type === 'update') {
            updateAdminMasterPincodeData(editData.id, payload, callback => {
                setLoader(false)
                const isSuccess = callback && (
                    callback.id ||
                    callback.message === 'success' ||
                    callback.status === 'success' ||
                    callback === 'success'
                )
                if (isSuccess) {
                    setPopupState(true)
                    setPopupStatus('Pincode updated successfully!')
                    setTimeout(() => handleSavebtn(), 2000)
                } else {
                    setPopupState(true)
                    setPopupStatus(callback?.message || 'Something went wrong, please try again!')
                    removePopup()
                }
            })
        }
    }

    return (
        <>
            {loader ? <Loader /> : ''}
            {popupState ? <PopUp closePopup={closePopup} popupStatus={popupStatus} /> : ''}

            <div className="AddEditExecutor">
                <h3 className="heading">{pageTitle}</h3>

                <div className="forms">
                    <div className="row">

                        {/* Pincode */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="pincode">
                                    Pincode <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    className="inputtag"
                                    type="number"
                                    id="pincode"
                                    name="pincode"
                                    placeholder="Enter Pincode"
                                    value={data.pincode}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* Nearby Area */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="nearbyArea">Nearby Area</label>
                                <input
                                    className="inputtag"
                                    type="text"
                                    id="nearbyArea"
                                    name="nearbyArea"
                                    placeholder="Enter Nearby Area"
                                    value={data.nearbyArea}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* HQ Pincode */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="hqPincode">HQ Pincode</label>
                                <input
                                    className="inputtag"
                                    type="number"
                                    id="hqPincode"
                                    name="hqPincode"
                                    placeholder="Enter HQ Pincode"
                                    value={data.hqPincode}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* Spoke Location */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="spokeLocation">Spoke Location</label>
                                <input
                                    className="inputtag"
                                    type="text"
                                    id="spokeLocation"
                                    name="spokeLocation"
                                    placeholder="Enter Spoke Location"
                                    value={data.spokeLocation}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* Hub */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="hub">Hub</label>
                                <input
                                    className="inputtag"
                                    type="text"
                                    id="hub"
                                    name="hub"
                                    placeholder="Enter Hub"
                                    value={data.hub}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* State */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="state">State</label>
                                <input
                                    className="inputtag"
                                    type="text"
                                    id="state"
                                    name="state"
                                    placeholder="Enter State"
                                    value={data.state}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* Distance From Spoke */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label htmlFor="distanceFromSpoke">Distance from Spoke (km)</label>
                                <input
                                    className="inputtag"
                                    type="number"
                                    id="distanceFromSpoke"
                                    name="distanceFromSpoke"
                                    placeholder="Enter Distance in km"
                                    value={data.distanceFromSpoke}
                                    onChange={handleChange}
                                    min="0"
                                />
                            </div>
                        </div>

                        {/* Status Toggle */}
                        <div className="col-sm-6 col-xs-12">
                            <div className="formgrp">
                                <label>Status</label>
                                <div
                                    className={`togglebtn ${data.isActive ? 'active' : 'inactive'}`}
                                    style={{ width: '15%', marginTop: '5px', cursor: 'pointer' }}
                                    onClick={handleToggle}
                                    title={data.isActive ? 'Active — click to deactivate' : 'Inactive — click to activate'}
                                >
                                    <button className="btn" style={{ padding: '15px' }}></button>
                                </div>
                                <span style={{ fontSize: '12px', color: data.isActive ? '#1c9146' : '#d9534f', marginTop: '4px', display: 'block' }}>
                                    {data.isActive ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>

                    </div>

                    <div className="savebtn">
                        <button className="btn back" onClick={() => handleSave('back')}>Back</button>
                        <button className="btn" onClick={() => handleSave(isEdit ? 'update' : 'save')}>
                            {isEdit ? 'Update' : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
